// https://codepen.io/geoffhtaylor3d/pen/eYEmxBz
export function setNearMap(map) {
    const layerID = "Nearmap Tile API";
    const NEARMAP_API_KEY = process.env.REACT_APP_NEARMAP_API_KEY;
    const NEARMAP_API_BASE_URL = "https://api.nearmap.com/tiles/v3/Vert/{z}/{x}/{y}.jpeg";
    const TILE_URL = `${NEARMAP_API_BASE_URL}?apikey=${NEARMAP_API_KEY}&tertiary=satellite`;
    // Create a tile layer, configured to fetch tiles from TILE_URL.
    const layer = new google.maps.ImageMapType({
        name: layerID,
        getTileUrl: function(coord, zoom) {
            const url = TILE_URL.replace("{x}", coord.x).replace("{y}", coord.y).replace("{z}", zoom);
            return url;
        },
        tileSize: new google.maps.Size(256, 256),
        minZoom: 0,
        maxZoom: 24,
    });

    // Apply the new tile layer to the map.
    // map.mapTypes.set(layerID, layer);
    // map.setMapTypeId(layerID);
    map.overlayMapTypes.insertAt(0, layer);
}
